import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RampIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 35 30"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M34.286 29.574v.131l-18.674.007v-.138c2.693-1.553 4.552-3.134 6.224-4.787h7.668zM29.659 4.741 24.926 0h-.138s.08 8.835-7.867 16.871C9.145 24.736 0 24.753 0 24.753v.138l4.822 4.823s9.012.091 16.972-7.882c7.931-7.947 7.865-17.091 7.865-17.091"
		></path>
	</svg>
))
